import { SecureRoute } from 'components/shared/secure_route';
import { ViewMounter } from 'components/view_mounter';
import React from 'react';
import { Panel, PanelPresets, UserPermissionsIds } from 'utility/enumerations';

function AdminCertDocsContainerScreen() {
  return (
    <div>
      <SecureRoute
        path="/certification-documentation/certification_doc_search"
        pathPermissionId={UserPermissionsIds.AccessCertificationDocAll}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/certification_documentation/certification_doc_search',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: { isAdmin: true },
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/certification-documentation/search-results/:type"
        pathPermissionId={UserPermissionsIds.AccessCertificationDocAll}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/certification_documentation/grid/certification_documentation_grid',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/certification-documentation/arf/:id"
        pathPermissionId={UserPermissionsIds.ReadCertDocArf}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/certification_documentation/certification_types/arf_documentation/arf_form.tsx',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/certification-documentation/skc/:id"
        pathPermissionId={UserPermissionsIds.ReadCertDocSkc}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/certification_documentation/certification_types/skc_documentation/skc_form.tsx',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/certification-documentation/2pc/:id"
        pathPermissionId={UserPermissionsIds.ReadCertDocSpc}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/certification_documentation/certification_types/2pc_documentation/2pc_form',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/certification-documentation/cmp/:id"
        pathPermissionId={UserPermissionsIds.ReadCertDocCmp}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/certification_documentation/certification_types/cmp_documentation/cmp_form',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/certification-documentation/rfe/:id"
        pathPermissionId={UserPermissionsIds.ReadCertDocRfe}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/certification_documentation/certification_types/rfe_documentation/rfe_form',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
    </div>
  );
}

export default AdminCertDocsContainerScreen;
